import { useState } from "react";
import TopupList from "./components/TopupList/TopupList";
import Filters from "./components/Filters/Filters";
import TopupHero from "./components/TopupHero/TopupHero";
import { TopupListingProvider } from "./context/TopupListingContext";
import "./TopupListing.css";

export default function TopupListing() {
  const [filters, setFilters] = useState({});
  return (
    <TopupListingProvider value={{ filters, setFilters }}>
      <div className="bg-background-minimal flex h-full flex-col gap-4">
        <div className="topup-listing-gradient relative isolate flex w-full flex-col gap-5 px-5 pt-10 md:px-20 md:pt-10">
          <TopupHero />
          <div className="flex items-center justify-between">
            <div className="scrollbar-hide flex-1 overflow-x-scroll">
              <Filters />
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col gap-4 px-5 pb-10 md:px-20">
          <TopupList />
        </div>
      </div>
    </TopupListingProvider>
  );
}
